import { useTranslation } from 'react-i18next'

import { FormatPrice, Text } from '@reveni-io/reveni-ui'

import { getSumOfSelectedConcepts } from '@/returns/helpers/helpers'

import * as Styles from './styles'

const TotalRefundAmount = ({ selectedConcepts, currency, extraAmount, showExtra, hasError }) => {
  const { t } = useTranslation()

  let concepts = [...selectedConcepts]

  if (showExtra) {
    concepts = [...concepts, { amount: extraAmount }]
  }

  const total = getSumOfSelectedConcepts(concepts)

  return (
    <Styles.Container hasError={hasError}>
      <Text type="titleS">{total >= 0 ? t('Reembolso') : t('Pago pendiente')}</Text>
      <Text type="titleS">
        <FormatPrice currency={currency}>{Math.abs(total)}</FormatPrice>
      </Text>
    </Styles.Container>
  )
}

export default TotalRefundAmount
